import { graphql, useStaticQuery } from 'gatsby';

export const useFieldsIcons = () => {
  const { wrapper } = useStaticQuery(graphql`
    query {
      wrapper: allAirtableFields(
        sort: {fields: rowIndex},
        filter: {data: {Picto: {elemMatch: {filename: {ne: null}}}}}
      ) {
        nodes {
          data {
            Picto {
              thumbnails { full { url } }
              src { publicURL }
            }
            Key
          }
        }
      }
    }
  `);

  return wrapper.nodes;
};

export default useFieldsIcons;
